export default class VocabularySearchCoverage {
    word = true;

    linkerWords: boolean;

    genericNotes: boolean;

    meaning: boolean;

    examples: boolean;

    notes: boolean;
}
